export default __webpack_public_path__ + "static/media/12-4.9e1df5a6.png";